module.exports = __webpack_public_path__ + "static/img/装饰19.8a6396d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰19.svg
// module id = HqQQ
// module chunks = 2